// import zhLocale from 'element-ui/lib/locale/lang/zh-CN' //引入element语言包
const cn = { // Nhập vào gói ngôn ngữ element
  login: { // 登录页面 Trang đăng nhập
    dlym01: 'Chào mừng',
    dlym02: 'Chưa có tài khoản?',
    dlym03: 'Đăng ký',
    dlym04: 'Vui lòng nhập số tài khoản',
    dlym05: 'Vui lòng nhập mật khẩu',
    dlym06: 'Ghi nhớ mật mã',
    dlym07: 'Quên mật mã?',
    dlym08: 'Đăng nhập',
    dlym09: 'Đang đăng nhập. ..',
    dlym10: 'Đăng nhập thành công',
    dlym11: 'Không có dữ liệu.',
    dlym12: 'Đã hiểu.',
    dlym13: 'Thoát thành công',
	  dlym14: 'Miễn phí tạo tài khoản'
  },
  register: { // 注册页面 Trang đăng ký
    zcym01: 'Chào mừng đăng ký',
    zcym02: 'Đã có tài khoản?',
    zcym03: 'Đăng nhập ngay',
    zcym04: 'Vui lòng nhập số tài khoản',
    zcym05: 'Vui lòng nhập mật khẩu',
    zcym06: 'Vui lòng nhập lại mật khẩu',
    zcym07: 'Vui lòng nhập mã mời (tùy chọn)',
    zcym08: 'Đăng ký',
    zcym09: 'Liên hệ CSKH',
    zcym10: 'Đang đăng ký. ..',
    zcym11: 'Vui lòng nhập từ 6 đến 20 chữ đặti thường, chữ hoa và số',
    zcym12: 'Hai lần cài đặt mật khẩu không phù hợp'
  },
  vip: {
    vip01: 'Chi tiết Hội viên VIP ',
    vip02: 'Tổng cược',
    vip03: 'Tuần lễ cược',
    vip04: 'Quà tặng',
    vip05: 'Tỷ lệ hoàn trả đặt nhân',
    vip06: 'Loại trò chơi',
    vip07: 'Trò chơi',
    vip08: 'Hoàn trả'
  },
  yjjlbl: {
    yjjlbl01: 'Tỷ lệ tiền thưởng hoa hồng',
    yjjlbl02: 'VIP cấp dưới',
    yjjlbl03: 'Tỷ lệ'
  },
  szcmlx: {
    szcmlx01: 'loại chip',
    szcmlx02: 'USDT',
    szcmlx03: 'nhân dân tệ',
    szcmlx04: 'Không có lời nhắc trong ngày',
    szcmlx05: 'Không có lời nhắc trong 7 ngày',
    szcmlx06: 'Gửi đi',
    szcmlx07: 'Xác nhận',
    szcmlx08: 'Để đảm bảo an toàn cho tài khoản và tiền của bạn, vui lòng liên kết địa chỉ email của bạn.'
  },
  yqhy: {
    yqhy01: 'Link Telegram',
    yqhy02: 'Link Web',
    yqhy03: 'Mã mời',
    yqhy04: 'cao nhất tới',
    yqhy05: '',
    yqhy06: 'copy',
    yqhy07: 'Chia sẻ Link-Lĩnh tiền hoa hồng',
    yqhy08: 'Thành viên mới hôm nay',
    yqhy09: 'Số người cấp dưới',
    yqhy10: 'Thành công sao chép',
    yqhy11: 'Mời bạn bè và nhận hoa hồng cao tới',
    yqhy12: '',
    yqhy13: 'Mời bạn bè',
	  yqhy14: 'Nhấp vô chia sẻ',
    yqhy15: 'Chia sẻ đến',
    yqhy16: 'TG chia sẻ một chạm',
    yqhy17: 'Sao chép liên kết TG',
    yqhy18: 'Sao chép liên kết trang web',
    yqhy19: 'WhatsApp chia sẻ một chạm'
  },
  contact: { // 联系客服页面Trang liên hệ khách hàng
    lxkf01: 'CSKH',
    lxkf02: 'CSKH Telegram',
    lxkf03: 'Kênh chính thức',
    lxkf04: 'Tìm kiếm',
    lxkf05: 'CSKH VIP',
    lxkf06: 'CSKH 24/7',
    lxkf07: 'Sẵn sàng lắng nghe'
  },
  bottomTab: { // 主模块 Mô-đun Chính
    zmk01: 'Trang chủ',
    zmk02: 'Khuyến Mãi',
    zmk03: 'Đại lý',
    zmk04: 'Tài khoản',
    zmk05: 'Vui lòng đăng nhập',
    zmk06: 'Giới thiệu',
    zmk07: 'Menu',
    zmk08: 'CSKH',
    zmk09: 'Người dùng không tồn tại',
    zmk10: 'Nhắc nhở',
    zmk11: 'Bạn chưa đăng nhập, vui lòng đăng nhập',
    zmk12: 'Quay lại trang chủ',
    zmk13: 'Liên hệ CSKH',
    zmk14: 'Tải xuống'
  },
  home: { // 首页 Trang chủ
    sy01: 'Đăng nhập',
    sy02: 'Đăng ký',
    sy03: 'Nạp tiền',
    sy04: 'Rút tiền',
    sy05: 'Nhiệm vụ',
    sy06: 'Thu nhập',
    sy07: 'Giới thiệu',
    sy08: 'Lịch sử',
    sy09: 'HOT',
    sy10: 'Điện tử',
    sy11: 'Đánh Bài',
    sy12: 'Casino',
    sy13: 'Thể Thao',
    sy131: 'Bắn đặt',
    sy1311: 'Phim ảnh',
    sy132: 'Xổ Số',
    sy133: 'Hash',
    sy14: 'Cược cào',
    sy15: 'Cược 1 phút',
    sy37: 'LKhông xuất hiện vào lần sau!',
    sy16: 'PG',
    sy17: 'Kaiyuan',
    sy18: 'PP',
    sy19: 'CR',
    sy20: 'DB',
    sy21: 'Thể dục Hoàng Gia',
    sy22: 'Điện tử',
    sy23: 'Cờ bài',
    sy24: 'Điện tử',
    sy25: 'Người thật',
    sy26: 'Câu đặt kaiyuan',
    sy27: 'Chọn tiêu chí lọc',
    sy28: 'Tìm kiếm trò chơi',
    sy29: 'Mua tiền điện tử',
    sy30: 'Giới thiệu VPN',
    sy31: 'Huobi',
    sy32: 'Binance',
    sy33: 'OE',
    sy34: 'ZB',
    sy35: 'business partners',
    sy36: 'Giấy phép chứng nhận',
    sy38: 'Thêm vào màn hình chính',
    sy39: 'Xem tất cả',
    sy40: 'HOT',
    sy41: 'Hủy',
    sy42: 'Sắp ra mắt, xin chờ đợi',
    sy43: 'Xem gần đây',
    sy44: 'Area restrictions',
    sy45: 'please try remote way',
    sy46: 'CSKH'
  },
  czym: { // 充值页面 Trang nạp tiền
    czym01: 'Nạp tiền',
    czym02: 'Nạp tiền tài khoản',
    czym03: 'Loại tiền tệ được hỗ trợ',
    czym04: 'USDT',
    czym05: 'Huione-BYWallet',
    czym06: 'Ví Trực tuyến',
    czym07: 'Địa chỉ Ví tiền gửi của bạn',
    czym08: 'Sao chép địa chỉ, tự động nạp tiền',
    czym09: 'Sao chép thành công',
    czym10: 'Số tiền nạp tối thiểu là 10USDT',
    czym111: 'Nhắc nhở：', // Tăng mới
    czym11: 'Hãy đảm bảo rằng mạng lưới bạn đang sử dụng để giao dịch là mạng TRON và giao thức được sử dụng là giao thức TRC20. Nếu không tiền gửi sẽ không đến được tài khoản game của bạn và nền tảng sẽ không chịu trách nhiệm. Hãy đảm bảo khoản tiền gửi của bạn không thấp hơn giới hạn hiện tại và nó sẽ được tự động ghi có sau khi bạn nạp tiền.',
    czym12: 'PPhương thức nạp(ABA nạp tiền',
    czym121: 'liên hệ CSKH>）',
    czym13: 'Huione',
    czym14: 'HuioneApp',
    czym15: 'Tên tài khoản',
    czym16: 'Số đẹp',
    czym17: 'Sao chép',
    czym18: 'Nạp hoàn tất! Liên hệ cộng điểm',
    czym19: 'Vui lòng sử dụng chức năng chuyển khoản trên ứng dụng điện thoại huione APP để chuyển tiền đến SỐ TÀI KHOẢN Ở TRÊN. Hỗ trợ chuyển bằng USD huione và USDT huione.',
    czym20: 'Tiền nạp USD được quy đổi sang USDT theo tỷ lệ 1:1, số tiền nạp tối thiểu là $10',
    czym21: 'Vui lòng nhập số tiền nạp',
    czym22: 'Có thể chọn số tiền nạp',
    czym23: 'Xác nhận',
    czym24: 'Số tiền nạp',
    czym25: 'Mã QR Huione này có hiệu lực theo múi giờ Bắc Kinh',
    czym26: 'Mã QR có hiệu lực trong 10 phút, vui lòng quét mã bằng ứng dụng Huione trước khi hết hạn để hoàn tất lần nạp',
    czym27: 'Quay về',
    czym28: '$10 Tiền nạp USD được quy đổi sang USDT theo tỷ lệ 1:1, số tiền nạp tối thiểu là $10',
    czym281: 'Vui lòng xác minh thông tin tài khoản nạp tiền trước khi nạp.',
    czym29: 'Tên tài khoản',
    czym30: 'Số đẹp',
    czym31: 'Sao chép',
    czym32: 'Thánh toán hoàn tất. Liên hệ CSKH cộng điểm!',
    czym33: 'Vui lòng chuyển tiền vào tài khoản thông qua chức năng chuyển khoản của ứng dụng BYWallet trên điện thoại di động của bạn. Chúng tôi hỗ trợ chuyển khoản bằng BYWallet USD và BYWallet USDT',
    czym34: '$10 Tiền nạp USD được quy đổi sang USDT theo tỷ lệ 1:1, số tiền nạp tối thiểu là $10',
    czym35: 'Nạp tiền thành công ', //
    czym36: 'Thanh toán ngay',
    czym37: 'Mã QR thanh toán',
    czym38: 'Tài khoản của bạn bị hạn chế, vui lòng liên hệ !',
    czym39: 'CSKH',
    czym40: '', // 此处空，不翻译
    czym41: 'USDT',
    czym42: 'Loại tiền tệ này hiện không được hỗ trợ',
    czym43: 'Ví tiền BYWallet',
    czym44: 'Tải ứng dụng Huione >',
    czym45: 'Tải ứng dụng BYWallet>',
    czym46: 'Phương thức nạp tiền',
    czym47: 'Số tiền / Trạng thái',
    czym48: 'Phương thức rút tiền',
	  czym49: 'Chọn loại tiền cần rút',
    czym50: 'Sau khi nạp tiền cần phải',
    czym51: 'Chỉ có thể rút tiền sau khi hoàn thành đủ số vòng cược',
    czym52: 'Kiểm tra tiền đã được nhận chưa>',
    czym53: 'Đang kiểm tra···',
    czym54: 'Nạp tiền USDT thành công！',
    czym55: 'Số tiền nạp：',
    czym56: 'Số dư sau khi nạp：',
    czym57: 'Tiếp tục nạp',
    czym58: 'Quay lại trang chủ（',
    czym59: 'Chưa nhận được？',
    czym60: 'Vui lòng liên hệ CSKH',
    czym61: 'Liên hệ CSKH',
    czym62: 'Thời gian nạp：',
    czym63: 'Liên hệ CSKH',
    czym64: 'Chưa đăng ký wallet',
    czym65: 'Đăng ký nhanh',
    czym66: '钱包'
  },
  txym: { // 提现页面Trang rút tiền
    txym01: 'Rút tiền',
    txym02: 'Rút tiền qua trang Web',
    txym03: 'Rút tiền qua TG',
    txym04: 'Rút tiền bằng tài khoản',
    txym05: 'Loại tiền tệ được hỗ trợ',
    txym06: 'USDT',
    txym07: 'Huione USD',
    txym08: 'Ví tiền BYWallet',
    txym09: 'Địa chỉ ví tiền của bạn',
    txym10: 'Thêm địa chỉ',
    txym11: 'Số tiền rút',
    txym12: 'Vòng cược còn lại',
    txym13: 'Số tiền rút thấp nhất',
    txym14: 'Rút toàn bộ',
    txym15: 'Số dư',
    txym16: 'Mật mã rút tiền',
    txym17: 'Nhấp thiết lập mật mã rút tiền',
    // txym18: 'Số tiền rút tối thiểu là 10U , Miễn phí rút tiền',
    txym18: 'Số tiền rút tối thiểu là',
    txym181: 'U，Phí giao dịch đơn lẻ 0U',
    txym19: 'Chỉ có thể rút tiền khi chơi đủ vòng cược hiển thị hoàn thành về 0',
    txym191: 'Game Hash,PC28 vòng cược không nằm',
    txym192: 'trong  hiển',
    txym193: '，thị hoàn thành vòng cược',
    txym20: 'Rút tiền',
    txym201: 'Lần rút tiền đầu tiên,Liên hệ CSKH',
    txym202: 'Vòng cược còn lại',
    txym203: '',
    txym21: 'Tên Huione của bạn',
    txym211: 'Vui lòng ghi / chọn địa chỉ',
    txym22: 'Vui lòng nhập tên Huione của bạn (Ví dụ ',
    txym23: 'Tài khoản Huione của bạn',
    txym24: 'Vui lòng nhập TK Huione của bạn (Ví dụ ',
    txym25: 'Số tiền rút',
    txym26: 'Vòng cược còn lại',
    txym27: 'Số tiền rút thấp nhất',
    txym28: 'Rút toàn bộ',
    txym29: 'Số dư',
    txym30: 'Mật mã rút tiền',
    txym31: 'Thiết lập mật mã rút tiền',
    txym32: '0U Số tiền rút tối thiểu là 10U , Miễn phí rút tiền',
    txym33: 'Chỉ có thể rút tiền khi chơi đủ vòng cược ,hiển thị hoàn thành về 0',
    txym34: 'Rút tiền',
    txym35: 'Tên BYWallet của bạn',
    txym36: 'Vui lòng nhập tên BYWallet của bạn (Ví dụ',
    txym37: 'Tài khoản BYWallet của bạn',
    txym38: ' (e.g.Vui lòng nhập TK BYWallet của bạn (Ví dụ',
    txym39: 'Số tiền rút',
    txym40: 'Vòng cược còn lại',
    txym41: 'Số tiền rút thấp nhất',
    txym42: 'Rút toàn bộ',
    txym43: 'Số dư',
    txym44: 'Mật mã rút tiền',
    txym45: 'Thiết lập mật mã rút tiền',
    txym46: '0U Số tiền rút tối thiểu là 10U , Miễn phí rút tiền',
    txym47: 'Chỉ có thể rút tiền khi chơi đủ vòng cược ,hiển thị hoàn thành về 0',
    txym48: 'Rút tiền',
    txym49: 'Rút tiền bằng tài khoản',
    txym50: 'Loại tiền tệ được hỗ trợ',
    txym51: 'Số dư',
    txym52: '0U, Số tiền rút tối thiểu là 10U , Miễn phí rút tiền',
    txym53: 'Để đảm bảo tiền rút được an toàn, vui lòng rút qua bot chính thức',
    txym54: 'Rút tiền (Chuyển đến Robot)',
    txym55: 'Vui lòng nhập mật khẩu rút tiền',
    txym56: 'Vui lòng xác nhận mật khẩu rút tiền',
    txym57: 'Vui lòng nhập mã xác minh email',
    txym58: 'Khả dụng',
    txym59: 'Huione',
    txym60: 'BYWallet',
    txym61: 'Mã vùng điện thoại di động của bạn',
    txym62: 'Vui lòng nhập mã vùng điện thoại di động của bạn (ví dụ',
    txym63: 'Số điện thoại di động của bạn',
    txym64: 'Vui lòng nhập số điện thoại di động của bạn (ví dụ',
    txym65: 'Vui lòng nhập tên Huione',
    txym66: 'Vui lòng nhập mã vùng điện thoại di động',
    txym67: 'Vui lòng nhập số điện thoại di động của bạn',
    txym68: 'Liên kết địa chỉ',
    txym69: 'Lời nhắc thân thiện',
    txym70: 'Để đảm bảo an toàn tài sản, hãy đặt mật khẩu rút tiền！',
    txym71: 'Đi đặt mật khẩu rút tiền',
    txym72: 'Tên',
    txym73: 'tài khoản',
    txym74: 'Nhập tên(e.g.',
    txym75: 'Nhập tài khoản(e.g.',
    txym76: 'Địa chỉ rút tiền của bạn'
  },
  rwzx: { // 任务中心Trung tâm nhiệm vụ
    rwzx01: 'Trung tâm khuyến mãi',
    rwzx02: 'Đăng ký tham gia',
    rwzx03: 'Nhận',
    rwzx04: 'Chờ nhận',
    rwzx05: 'Đã nhận',
    rwzx06: 'Có thể nhận'
  },
  wdsr: { // 我的收入Thu nhập của tôi
    wdsr01: 'Thu nhập của tôi',
    wdsr02: 'Đồng đội của tôi',
    wdsr03: 'Thưởng vòng cược ',
    wdsr04: 'Nhận',
    wdsr05: 'Nhận thành công',
    wdsr06: 'Không có tiền hoa hồng có thể nhận',
    wdsr07: '',
    wdsr08: 'Tổng cược ',
    wdsr09: 'Đặt cược hợp lệ',
    wdsr10: 'Lịch sử hoàn cược',
    wdsr11: 'Lịch sử nhận',
    wdsr12: 'Lịch sử tiền hoàn cược',
    wdsr13: 'Thời gian',
    wdsr14: 'Số tiền',
    wdsr15: 'Trạng thái',
    wdsr16: 'Không còn dữ liệu tìm kiếm',
    wdsr17: 'Hôm qua',
    wdsr18: 'Hôm nay',
    wdsr19: 'Lịch sử',
    wdsr20: 'Tiền hoa hồng có thể nhận',
    wdsr21: 'Nhận',
    wdsr22: '',
    wdsr23: 'Số người cấp dưới',
    wdsr24: '',
    wdsr25: 'Thanh toán hoa hồng',
    wdsr26: 'Lịch sử nhận',
    wdsr27: 'Hôm qua',
    wdsr28: 'Hôm nay',
    wdsr29: 'Lịch sử',
    wdsr30: '',
    wdsr31: '',
    wdsr32: 'Lịch sử tiền hoa hồng',
    wdsr33: 'Hiệu suất hôm nay',
    wdsr34: '',
    wdsr341: 'Tiền hoa hồng được thanh toàn ngay lập tức, có thể chậm trễ trong quá trình đồng bộ hoá dữ liệu với đặtc nhà cung cấp khiến việc thanh toán trễ 10-20 phút',
    wdsr342: 'Nếu khoản hoàn tiền không được nhận trong vòng một tháng, nó sẽ tự động về 0',
    wdsr35: 'Xem hiệu suất',
    wdsr36: 'Phân loại trò chơi',
    wdsr37: 'Hiệu suất cấp dưới',
    wdsr38: 'Tỷ lệ hiệu suất',
    wdsr39: 'Hash',
    wdsr40: 'Điện tử',
    wdsr41: 'Đánh Bài',
    wdsr42: 'Casino',
    wdsr43: 'Thể Thao',
    wdsr44: 'Hôm nay',
    wdsr45: 'Hôm qua',
    wdsr46: 'Tên',
    wdsr47: 'Vòng cược cá nhân',
    wdsr48: 'Telegram',
    wdsr49: 'Hoa hồng điện tử của bạn',
    wdsr50: '，Cao nhất',
    wdsr51: 'Cao nhất tới',
    wdsr52: '%>',
    wdsr53: 'HOT',
    wdsr54: 'Link đề xuất TG của bạn',
    wdsr55: 'Liên kết chia sẻ khác',
    wdsr56: 'Loại hình',
    wdsr57: 'Thu chi / số dư'
  },
  tzjl: { // 投注记录Lịch sử đặt cược
    tzjl01: 'Tóm tắt lịch sử đặt cược',
    tzjl02: 'Tổng đặt cược',
    tzjl03: 'Lượt',
    tzjl04: 'Thắng thua',
    tzjl05: 'Mức cược',
    tzjl06: 'Cược hợp lệ',
    tzjl07: 'Lịch sử đặt cược',
    tzjl08: 'Hash',
    tzjl09: 'Điện tử',
    tzjl10: 'Đánh Bài',
    tzjl11: 'Casino',
    tzjl12: 'Thể Thao',
    tzjl13: 'Chi tiết đặt cược',
    tzjl14: 'Tổng cộng',
    tzjl15: 'Đặt cược hợp lệ',
    tzjl16: 'Thắng thua',
    tzjl17: 'Tổng cộng',
    tzjl18: 'Đặt cược hợp lệ',
    tzjl19: 'Thắng thua',
    tzjl20: 'Mã số phiếu cược',
    tzjl21: 'Trò chơi tham gia',
    tzjl22: 'Khu vực đặt cược',
    tzjl23: 'Kết quả đặt cược',
    tzjl24: 'Số tiền đặt cược',
    tzjl25: 'Số tiền hoàn thưởng',
    tzjl26: 'Mã kỳ quay thưởng',
    tzjl27: 'Địa chỉ ví tiền TRon',
    tzjl28: 'Hash key',
    tzjl29: 'Thời gian đặt cược',
    tzjl30: 'Nhấn để xác minh',
    tzjl31: 'Tổng cộng',
    tzjl32: 'Đặt cước hợp lệ',
    tzjl33: 'Thắng thua',
    tzjl34: 'Mã số phiếu cược',
    tzjl35: 'Trò chơi tham gia',
    tzjl36: 'Thời gian đặt cược',
    tzjl37: 'Số tiền đặt cược',
    tzjl38: 'Đặt cược hợp lệ',
    tzjl39: 'Kết quả thắng thua',
    tzjl40: 'Có chắc thanh toán',
    tzjl41: 'Mã số mở thưởng',
    tzjl42: 'Khu vực đặt cược',
    tzjl43: 'Kết quả trúng thưởng',
    tzjl44: 'Số tiền đặt cược',
    tzjl45: 'Số tiền hoàn thưởng',
    tzjl46: 'Mã kỳ quay thưởng',
    tzjl47: 'Mã Số mở thưởng',
    tzjl48: 'Thời gian đặt cược',
    tzjl49: 'Tên trò chơi',
    tzjl50: 'Đang tải...',
    tzjl51: 'Kéo xuống để làm mới...',
    tzjl52: 'Thả ra để làm mới'
  },
  mywd: { // 我的Của tôi
    wd01: 'Mời bạn bè',
    wd02: 'Thu nhập của tôi',
    wd03: 'Lịch sử đặt cược',
    wd04: 'Trung tâm an toàn',
    wd05: 'Nạp tiền',
    wd06: 'Rút tiền',
    wd07: 'Ví tiền trung tâm',
    wd08: 'Lì xì',
    wd09: 'Khẩu lệnh',
    wd10: 'Thắng thua',
    wd11: 'Nạp rút tiền',
    wd12: 'giao dịch',
    wd13: 'Hợp tác đại lý',
    wd14: 'Buy crypto',
    wd15: 'VPN Giới thiệu VPN',
    wd16: 'Thoát đăng nhập',
    wd17: 'Nhiệm vụ',
    wd18: 'Trung tâm an toàn',
    wd19: 'Số dư',
    wd20: 'Mời bạn bè thưởng cao tới',
    wd21: '',
    wd22: 'Chi tiết',
    wd23: 'copy',
    wd24: 'Hoán đổi chip',
    wd25: 'Ngôn ngữ',
    wd26: 'Phiếu thưởng',
    wd27: 'Chi tiết phiếu thưởng',
    wd28: 'Thời gian',
    wd29: 'Mã Phiếu',
    wd30: 'Vòng quay',
    wd31: 'Chi tiết',
    wd32: 'Thời gian',
    wd33: 'phần thưởng'
  },
  aqzx: { // 安全中心Trugn tâm an toàn
    aqzx01: 'Bảo vệ toàn diện tài khoản của bạn',
    aqzx02: 'Thiết lập tài khoản',
    aqzx03: 'Thiết lập mail',
    aqzx04: 'Chỉnh sửa mail',
    aqzx05: 'Thay đổi mật mã đăng nhập',
    aqzx06: 'Thiết lập mật mã rút tiền',
    aqzx07: 'Thay đổi mật mã rút tiền',
    aqzx08: 'Quản lý địa chỉ rút tiền',
    aqzx09: 'Vui lòng nhập tài khoản',
    aqzx10: 'Vui lòng nhập mật mã đăng nhập',
    aqzx11: 'Vui lòng nhập lại mật khẩu xác nhận',
    aqzx12: 'Lấy mã xác nhận',
    aqzx13: 'Vui lòng nhập mã xác nhận TG',
    aqzx14: 'Vui lòng nhập mail',
    aqzx15: 'Vui lòng nhập mã xác nhận',
    aqzx16: 'Vui lòng nhập mật mã đăng nhập',
    aqzx17: 'Vì sự an toàn của tài khoản và số dư, vui lòng liên kết địa chỉ email của bạn',
    aqzx18: 'Vui lòng nhập mail mới',
    aqzx19: 'Gửi đi',
    aqzx20: 'Vui lòng nhập mật mã rút tiền ban đầu',
    aqzx21: 'Vui lòng nhập mật mã rút tiền mới',
    aqzx22: 'Vui lòng nhập mật mã rút tiền',
    aqzx23: 'Gửi đi',
    aqzx24: 'Quên mật mã',
    aqzx25: 'Vui lòng nhập mật mã ban đầu',
    aqzx26: 'Vui lòng nhập mật mã mới',
    aqzx27: 'Vui lòng nhập lại mật mã xác nhận',
    aqzx28: 'Gửi đi',
    aqzx29: 'Quên mật mã',
    aqzx30: 'Thêm địa chỉ',
    aqzx31: 'Địa chỉ đã liên kết',
    aqzx32: 'Thêm địa chỉ rút tiền mới',
    aqzx33: 'Thêm địa chỉ mới',
    aqzx34: 'Chọn thỏa thuận',
    aqzx35: 'Thêm địa chỉ',
    aqzx36: 'Vui lòng nhập địa chỉ',
    aqzx37: 'Lưu ý: Để bảo vệ tài sản, hãy chắc chắn rằng địa chỉ bạn thêm đúng với giao thức đã chọn — nếu sai có thể dẫn đến mất tiền',
    aqzx38: 'Xác định',
    aqzx39: 'Quên mật mã rút tiền',
    aqzx40: 'Vui lòng nhập địa chỉ mail',
    aqzx41: 'mail hiện tại',
    aqzx42: 'Vui lòng nhập mail ban đầu',
    aqzx43: 'mã xác nhận',
    aqzx44: 'Vui lòng nhập mã xác nhận',
    aqzx45: 'mail mới',
    aqzx46: 'Vui lòng nhập mail mới',
    aqzx47: 'Gửi lại',
    aqzx48: 'Vui lòng nhập địa chỉ mail chính xác',
    aqzx49: 'Thiết lập thành công',
    aqzx50: 'Tài khoản TG',
    aqzx51: 'mail',
    aqzx52: 'Mật mã đăng nhập',
    aqzx53: 'Mật mã rút tiền',
    aqzx54: 'Mật mã ban đầu',
    aqzx55: 'Mật mã mới',
    aqzx56: 'Mật mã 2 nhập không trùng khớp',
    aqzx57: 'Gửi thành công',
    aqzx58: 'Tài khoản',
    aqzx59: 'Vui lòng nhập tài khoản',
	  aqzx60: 'Mật mã rút tiền',
    aqzx61: 'Vui lòng nhập mật khẩu rút tiền'
  },
  wdhb: { // 我的红包Lì xì của tôi
    hb01: 'Số dư ví tiền hiện tại',
    hb02: 'Phát lì xì',
    hb03: 'Tổng tiền',
    hb04: 'Số lượng lì xì',
    hb05: 'Loại hình lì xì',
    hb06: 'Yêu cầu số tiền doanh thu',
    hb07: 'Thời gian hết hạn',
    hb08: 'Số dư lì xì',
    hb09: 'Lịch sử nhận',
    hb10: 'Link lì xì',
    hb11: 'Link lì xì TG',
    hb12: 'Gửi thông báo lì xì qua Telegram',
    hb13: 'Ghi chú',
    hb14: 'Phát lì xì',
    hb15: 'Tổng thành tiền',
    hb16: 'Số lượng lì xì',
    hb17: 'Loại hình lì xì',
    hb18: 'Số vòng cược yêu cầu',
    hb19: 'Thời gian hết hạn',
    hb20: 'Ghi chú',
    hb201: 'ghi chú 2',
    hb21: 'Xác nhận',
    hb22: 'Lì xì người mới',
    hb23: 'Lì xì tặng thưởng',
    hb24: '1 lần',
    hb25: 'lần',
    hb26: '3 lần',
    hb27: '4 lần',
    hb28: '5 lần',
    hb29: 'sau 1 ngày',
    hb30: 'sau 2 ngày',
    hb31: 'sau 3 ngày',
    hb32: 'Lì xì người mới: Tất cả người mới đều có thể nhận; Lì xì tặng thưởng: Mọi người đều có thể nhận',
    hb33: 'lần',
    hb34: 'Không',
    hb35: 'Mã chia sẻ lì xì',
    hb36: '10 lần'
  },
  hbkl: { // 红包口令Khẩu lệnh lì xì
    hbkl01: 'Nhập khẩu lệnh, nhận lì xì',
    hbkl02: 'Nhận lì xì'
  },
  sylb: { // 输赢列表Danh sách thắng thua
    sybb01: 'Báo cáo thống kê',
    sybb02: 'Thời gian',
    sybb03: 'Hoàn tiền cược',
    sybb04: 'Đặt cược',
    sybb05: 'Thắng thua',
    sybb06: 'Tổng số giao dịch',
    sybb07: 'Tổng thắng thua',
    sybb08: 'Dữ liệu cột thắng thua trong bảng là tổng số tiền thắng thua và tiền hoàn cược'
  },
  ctjl: { // 充提记录Lịch sử nạp và rút
    ctjl01: 'Lịch sử nạp và rút',
    ctjl02: 'Số dư ví tiền hiện tại',
    ctjl03: 'Mả số',
    ctjl04: 'Nạp/Rút',
    ctjl05: 'Tiền tệ nạp vào',
    ctjl06: 'Loại tiền tệ nạp vào',
    ctjl07: 'Phí Nạp/Rút',
    ctjl08: 'Số tiền Nạp/Rút',
    ctjl09: 'Số tiền nhận được',
    ctjl10: 'Hash giao dịch',
    ctjl111: 'Địa chỉ',
    ctjl112: 'Ghi chú',
    ctjl11: 'Thời gian Nạp/Rút',
    ctjl12: 'Loại tiền cần rút',
    ctjl13: 'Chi tiết nạp tiền',
    ctjl14: 'Chi tiết rút tiền'
  },
  jyjl: { // 交易记录Lịch sử giao dịch
    jyjl01: 'Lịch sử giao dịch',
    jyjl02: 'Giao dịch',
    jyjl03: 'Nạp tiền',
    jyjl04: 'Rút tiền',
    jyjl05: 'Khuyến Mãi',
    jyjl06: 'Loại hình',
    jyjl07: 'Thu chi / số dư'
  },
  gmhb: { // 购买货币Mua bán tiền tệ
    gmhb01: 'Mua tiền ảo',
    gmhb02: 'Sàn giao dịch đề xuất',
    gmhb03: 'Địa chỉ tài về',
    gmhb04: 'Hướng dẫn',
    gmhb05: 'Xem Hướng dẫn'
  },
  tjvpn: { // 推荐vpn đề xuất
    tjvpn01: 'Phần mềm liên quan cần tải',
    tjvpn02: 'Đề xuất phần mềm VPN',
    tjvpn03: 'Rocket VPN',
    tjvpn04: '1.1.1.1 VPN',
    tjvpn05: 'Download',
    tjvpn06: 'Tải ví tiền điện tử phổ biến',
    tjvpn07: 'Có thể nạp vào ví của mình thông qua nền tảng chuyển  ví tiền điện tử',
    tjvpn08: 'Tải xuống ứng dựng khác',
    tjvpn09: 'Robot chính thức',
    tjvpn10: 'Hướng dẫn đặt cược bằng Robot',
    tjvpn11: 'Tải xuống ứng dựng khác'
  },
  hxhash: { // 哈希
    hx01: 'Integrated Hash',
    hx02: '1.95~9.7 times lottery  return',
    hx03: 'The last 1 digit (ignoring letters and decimal points) is used as the result of the lottery.',
    hx04: 'Issued no',
    hx05: 'Beted no',
    hx06: 'More issued no',
    hx07: 'Current bets',
    hx08: 'My bets',
    hx09: 'Game rules',
    hx10: 'limit',
    hx11: 'BIG',
    hx12: 'SMALL',
    hx13: 'ODD',
    hx14: 'EVEN',
    hx15: 'B&O',
    hx16: 'S&E',
    hx17: 'B&E',
    hx18: 'S&O',
    hx19: 'Enter the amount',
    hx20: 'Comfirm',
    hx21: 'Reset',
    hx22: 'Keep bets',
    hx23: 'Bets',
    hx24: 'Round',
    hx25: 'The top of the table is the latest data, the number represents the number of times the number in the column has not appeared, the red numbers are the current lottery numbers',
    hx26: 'B&O means big and odd,S&E means small and even,B&E means big and even,S&O means small and odd,O&E means odd and even,B&S means big and small',
    hx27: 'Number Trend',
    hx28: 'O&E Trend',
    hx29: 'B&S Trend',
    hx30: 'Successful bet',
    hx31: 'Beted no：',
    hx32: 'Sorry, you lost',
    hx33: "This period's result",
    hx34: 'Lottery no',
    hx35: 'Details',
    hx36: 'Hash key',
    hx37: 'Verify',
    hx38: 'I see',
    hx39: 'Manual mode',
    hx40: 'Betting area',
    hx41: 'Issued no',
    hx42: 'Betting amount',
    hx43: 'Winning amount',
    hx44: 'Verify hash key',
    hx45: 'Video leads how to verify hash key',
    hx46: 'View',
    hx47: 'Issued time',
    hx48: 'Issued no',
    hx49: 'Wallet address',
    hx50: 'Hash key',
    hx51: 'Issued status',
    hx52: "The platform relies on a decentralized blockchain network to randomly generate the wallet address data for the next 24 hours and 28,800 issues(3 seconds a period) as the source of the issues, and after the issues the wallet private key is published so that the players can verify it, so that the platform can't manipulate the data, and all the records are transparent and traceable.",
    hx53: 'Click copy wallet private key hash to open any decentralized wallet, import the wallet private key hash, check if the wallet address is the same as the wallet address given by the platform！',
    hx54: 'Issues query',
    hx55: 'Issued no',
    hx56: 'Enter issued no or wallet address',
    hx57: 'How to verify',
    hx58: 'Issued time',
    hx59: 'Issued no',
    hx60: 'Wallet address',
    hx61: 'Hash key',
    hx62: 'Unissued no',
    hx63: 'Click on the lottery issue number, wallet address, and lottery private key hash content to copy it',
    hx64: 'Total bets',
    hx65: 'Bets',
    hx66: 'Vaild bets',
    hx67: 'Profit',
    hx68: 'Bet no',
    hx69: 'Participated game',
    hx70: 'Betting area',
    hx71: 'Winning situation',
    hx72: 'Betting amount',
    hx73: 'Payout amount',
    hx74: 'Issued no',
    hx75: 'Wallet address',
    hx76: 'Hash key',
    hx77: 'Bet time',
    hx78: 'Verify',
    hx79: 'Hash Even/Odd',
    hx80: 'Hash Bullfight',
    hx81: 'Hash Big/Small',
    hx82: 'Hash Banker/Player',
    hx83: 'Luckey Hash',
    hx84: 'Dice Even/Odd',
    hx85: 'Dice Big/Small',
    hx86: 'Bull1',
    hx87: 'Bull2',
    hx88: 'Bull3',
    hx89: 'Bull4',
    hx90: 'Bull5',
    hx91: 'Bull6',
    hx92: 'Bull7',
    hx93: 'Bull8',
    hx94: 'Bull9',
    hx95: 'BullBull',
    hx96: 'BULL PLAYER',
    hx97: 'Tie',
    hx98: '2times lottery  return',
    hx99: '1.95times lottery  return',
    hx100: 'key hash value from right to left read 3 (1-6) numbers (repeatable) for each lottery number as the lottery result.',
    hx101: 'Deposit',
    hx102: 'B',
    hx103: 'S',
    hx104: 'O',
    hx105: 'E',
    hx106: 'Congratulations,you win',
    hx107: "This period's result",
    hx108: 'Direct mode',
    hx109: 'Hash1Min Even/Odd',
    hx110: 'Hash1Min Big/Small',
    hx111: 'Hash1Min Bull',
    hx112: 'Hash1Min Banker/Player',
    hx113: 'Hash1Min Lucky',
    hx114: 'Dice1Min Even/Odd',
    hx115: 'Dice1Min Big/Small',
    hx116: 'Integrated Hash1Min',
    hx117: 'All',
    hx118: 'last issued no',
    hx119: 'current no',
    hx120: 'history  no',
    hx121: 'verify',
    hx122: 'all bets'
  },
  yxgz: { // 游戏规则
    yxgz01: 'Lottery rules',
    yxgz02: 'In order to ensure the absolute fairness of the game,the platform in advance to randomly generate the next 24 hours',
    yxgz03: 'data (3 seconds a period), in order to ensure that the bet is unissued period, the system issue of interval of 20 period,the wallet private key hash (KEY hash) as a result of the lottery number!',
    yxgz04: ' 28800 period of the opening wallet address ',
    yxgz05: 'In order to ensure the absolute fairness of the game,the platform in advance to randomly generate ',
    yxgz06: 'next 24 hours 28800 period of the opening wallet address',
    yxgz07: '...,Based on the private key hash value from right to left read 3 (1-6) numbers (repeatable) for each lottery number, as the lottery result.',
    yxgz08: "1.The last 5 digits of the key hash value (key hash)  will be the card face, for example: key hash value (00057aba), the card face is '57aba', the letters are '10', and the sum of the individual digits is compared",
    yxgz09: '2.Card type algorithm: Ox1Ox10 corresponds to 110 times',
    yxgz10: "3.When the player's card type is Ox10, Ox9, a 10% service fee will be deducted when winning",
    yxgz11: "4.If the current banker is: 57a. 5+7+10=22 'Ox2'",
    yxgz12: "5.If the current player is: aba. 10+10+10=30 'Ox10'",
    yxgz13: '6.If the point values are the same, a 1% service fee will be deducted and the principal will be refunded',
    yxgz14: "1.The last 5 digits of the key hash value (Key hash)  will be the card face, for example: key hash value (000a3b78), the card face is 'a3b78'",
    yxgz15: "2.The banker's card face is the first 2 digits. The player's card face is the last 2 digits. 0 is the smallest, 9 is the largest, and letters (abc) are 0",
    yxgz16: '3.If the current banker is: a, 3. The value is 3',
    yxgz17: '4.If the current player is: 7, 8. The value is 5',
    yxgz18: '5.Bet on banker win, after comparing the points, if the banker wins, it will pay 1.95 times',
    yxgz19: '6.Bet on player win, after comparing the points, if the player wins, it will pay 1.95 times',
    yxgz20: '7.Bet on tie win, after comparing the points, if the tie wins, it will pay 8 times',
    yxgz21: "8.If you bet on banker or player, and it's a tie, the bet will be refunded ",
    yxgz22: '1.The last 2 digits of the private key hash (Key hash) of the opening wallet are a combination of numbers or letters for the win',
    yxgz23: "issued no 2023122500006's key hash is ",
    yxgz24: 'e.g:',
    yxgz25: 'data (3 seconds a period), in order to ensure that the bet is unissued period, the system issue of interval of 20 period,the wallet private key hash (KEY hash) as a result of the lottery number!',
    yxgz26: '1.The last 1 digit of the key hash  will be the lottery result (ignoring letters)',
    yxgz27: '2.Digits 0、1、2、3、4 are recognized as  small numbers',
    yxgz28: '3. Digits 5、6、7、8、9 are recognized as  big numbers',
    yxgz29: '2.Digits 1、3、5、7、9 are recognized as  odd numbers',
    yxgz30: 'Digits 0、2、4、6、8 are recognized as  even numbers',
    yxgz31: 'Size: The sum of three dice is even, and the sum of three dice is odd. Please note: If the first, second, and third dice have the same number of points, you will take the [Odd] and [Even] bets.',
    yxgz32: 'Size: The sum of  three dice is 3-10 for small, and the sum of three dice is 11-18 for big. Please note: If the first, second, and third dice have the same number of points, you will take the [Big] and [Small] bets.',
    yxgz33: 'Read the 3 (1-6) digits (repeatable) in order from right to left and the lottery numbers are ',
    yxgz34: 'the last 1 digit is ',
    yxgz35: '10. The special code is to choose a number for betting, the selected number and the lottery number is the same as the winning',
    yxgz36: '4.Digits 1、3、5、7、9 are recognized as  odd numbers',
    yxgz37: '5. Digits 0、2、4、6、8 are recognized as  even numbers',
    yxgz38: '6.Digits 0、2、4  are recognized as  small and even numbers',
    yxgz39: '7. Digits 6、8 are recognized as  big and even numbers',
    yxgz40: '8. Digits5、7、9  are recognized as  big and odd numbers',
    yxgz41: '9. Digits 1、3 are recognized as  small and odd numbers',
    yxgz42: 'then the lottery result is ',
    yxgz43: 'The last 2 digits are ',
    yxgz44: ',the lottery result is even',
    yxgz45: ',the lottery result is small',
    yxgz46: ', the lottery result is lucky!',
    yxgz47: '，result is big',
    yxgz48: '开奖结果为大、双、大双，特码为'
  },
  cwm: {
    1: 'Thành công',
    5555: 'Chuyển hướng thất bại',
    8888: 'Hệ thống đang nâng cấp, vui lòng truy cập sau',
    9999: 'Hệ thống gặp sự cố, vui lòng liên hệ bộ phận chăm sóc khách hàng hoặc thử lại',
    1051: 'Người dùng không tồn tại',
    1052: 'Thao tác thất bại',
    1101: 'id của người dùng không được để trống',
    1102: 'Địa chỉ chuyển khoản USDT tương ứng của người dùng không được để trống',
    1103: 'Người dùng đã tồn tại',
    1104: 'Đăng ký thất bại, vui lòng liên hệ với quản trị viên',
    1105: 'Tài khoản không được để trống',
    1106: 'Mật mã không được để trống',
    1107: 'Vui lòng sử dụng số tài khoản có từ 6-20 ký tự',
    1108: 'Vui lòng sử dụng mật mã có từ 6-20 ký tự.',
    1109: 'Số tài khoản bạn nhập không chính xác. Vui lòng nhập lại',
    1110: 'Mật khẩu bạn nhập không chính xác. Vui lòng nhập lại',
    1111: 'Thao tác quá thường xuyên, vui lòng thử lại sau 10 phút',
    1112: 'Tài khoản hoặc mật khẩu không đúng. Đăng nhập không thành công',
    1113: 'Tài khoản đã được đăng ký. Vui lòng nhập lại',
    1114: 'Đăng ký thất bại, vui lòng liên hệ phận chăm sóc khách hàng',
    1115: 'Thiết bị hoàn cược bị lỗi',
    1120: 'Mã khuyến mãi không tồn tại',
    1121: 'Vui lòng chọn lịch sử nạp tiền',
    1122: 'Lịch sử nạp tiền không tồn tại',
    1123: 'Lỗi lịch sử nạp tiền',
    1124: 'Chương trình khuyến mãi đã đóng',
    1125: 'Lịch sử nạp tiền không phù hợp điều kiện Chương trình khuyến mãi',
    1126: 'Phần thưởng của lịch sử nạp tiền hiện đã nhận, không thể nhận thêm nữa!',
    1127: 'Nhận thưởng thất bại, vui lòng thử lại sau',
    1128: 'Vui lòng chọn số tiền cần nhận',
    1129: 'Lỗi hạn mức nhận',
    1130: 'Số vòng cược trong ngày không đủ, không đủ điều kiện nhận thưởng',
    1131: 'Phần thưởng ở danh mục này đã được nhận, không thể nhận lại',
    1132: 'Vượt quá phạm vi cược tối đa cho phép, vui lòng đặt lại cược',
    1133: 'Địa chỉ rút tiền, không được để trống',
    1134: 'Nhận thưởng thất bại, vui lòng thử lại sau',
    1135: 'Thêm thất bại, vui lòng thử lại sau',
    1136: 'Xóa thất bại, vui lòng thử lại sau',
    1137: 'Thông tin rút tiền thất bại',
    1138: 'Lấy liên kết Huione thất bại',
    1139: 'Lưu mã quét thanh toán bằng Huione thất bạn, vui lòng gửi lại!',
    1140: 'Tham số nạp tiền thủ công Huione bị lỗi',
    1141: 'Tham số nạp tiền thủ công BYWallet bị lỗi',
    1142: 'Địa chỉ không tồn tại',
    1143: 'Tạo link mời bạn bè thất bại, Vui lòng liện hệ CSKH',
    1144: 'Tạo link mời bạn bè thất bại, Vui lòng liện hệ CSKH',
    1145: 'Nhận tiền hoa hồng thất bại, vui lòng thử lại sau',
    1146: 'Không có dữ liệu để tra cứu',
    1147: 'Lưu thông tin hệ thống thất bại',
    1148: 'Gửi thông tin thất bại',
    1149: 'Gửi bao lì xì thành công, nhưng gửi thông báo thất bại',
    1150: 'Liên kết thất bại, vui lòng liên hệ bộ phận chăm sóc khách hàng',
    1151: 'Thiết lập thất bại, vui lòng thử lại',
    1152: 'Thao tác thất bại, vui lòng liên hệ bộ phận chăm sóc khách hàng',
    1153: 'Gửi email thất bại, vui lòng liên hệ bộ phận chăm sóc khách',
    1154: 'Trong vòng 24 giờ, cùng một mức tiền chỉ có thể nhận tối đa XXXXXX lần',
    1155: 'Độ dài địa chỉ rút tiền không chính xác',
    1156: 'Mở đầu địa chỉ rút tiền không chính xác',
    1157: 'Nội dung địa chỉ rút tiền không chính xác',
    1158: 'Đã có địa chỉ rút tiền giống nhau. Không thể thêm địa chỉ trùng lặp.',
    1159: 'Địa chỉ rút tiền không chính xác',
    1160: 'Địa chỉ rút tiền không tồn tại, không thể xóa',
    1161: 'Mật khẩu rút tiền chưa được thiết lập. Vui lòng thiết lập mật khẩu',
    1162: 'Mật khẩu rút tiền không được để trống',
    1163: 'Vui lòng sử dụng mật khẩu rút tiền từ 6-20 ký tự',
    1164: 'Mật khẩu rút tiền đã nhập không đúng',
    1165: 'Mật khẩu rút tiền không đúng',
    1166: 'Địa chỉ rút tiền không được để trống',
    1167: 'Thông tin rút tiền bạn nhập quá dài',
    1168: 'Số tiền rút tiền không được để trống',
    1169: 'Loại hình rút tiền không được để trống',
    1170: 'Loại hình rút tiền bị lỗi',
    1171: 'Lỗi định dạng số tiền, vui lòng phản hồi lại',
    1172: 'Số tiền vô hiệu, vui lòng phản hồi lại',
    1173: 'Hệ thống thất bải, vui lòng liên hệ bộ phận chăm sóc khách hàng',
    1174: 'Chuyển đổi số tiền bị lỗi',
    1175: 'Rút tiền thất bại, số dư không đủ',
    1176: 'Lỗi chức năng rút tiền, vui lòng gửi lại sau',
    1177: 'Không thể sử dụng địa chỉ rút tiền làm địa chỉ nạp tiền trên sàn game, cảm ơn',
    1178: 'út tiền thất bại',
    1179: 'Yêu cầu bị lỗi hoặc thông tin không đầy đủ',
    1180: 'Địa chỉ U rút tiền không thể để trống',
    1181: 'Thông tin rút tiền đã nhập quá dài',
    1182: 'Lỗi hệ thống hoặc thông tin không hoàn chỉnh',
    1183: 'Mã hash bất thường',
    1184: 'Hình thức chơi này đang tạm ngừng đặt cược',
    1185: 'Hình thức đặt cược không hợp lệ',
    1186: 'Lỗi số tiền đặt cược',
    1187: 'Vượt quá giới cho phép, vui lòng đặt cược lại',
    1188: 'Lỗi đọc dữ liệu số dư người chơi',
    1189: 'Số dư người chơi không đủ',
    1190: 'Mã hash bất thường',
    1191: 'Mã hash bất thường, vui lòng đặt lại hoặc liên hệ bộ phận chăm sóc khách hàng',
    1192: 'Đặt cược thất bại, vui lòng thử lại',
    1193: 'Đọc dữ liệu thất bại',
    1194: 'Mã số tìm kiếm không tồn tại',
    1195: 'Loại hình menu chơi bài không được để trống',
    1196: 'Loại hình chơi bài không được để trống',
    1197: 'Loại hình trờ chơi không được để trống',
    1198: 'Loại hình chơi bài không được để trống',
    1199: 'Mã hash bất thường',
    1200: 'Kỳ số hiện tại đã ngừng cho phép đặt cược',
    1201: 'Đặt cược thất bại, vui lòng thử lại hoặc liên hệ bộ phận chăm sóc khách hàng',
    1202: 'Mã số truy vấn không tồn tại',
    1203: 'Thông tin mở thường truy vấn không tồn tại hoặc chưa mở thưởng',
    1204: 'Dữ liệu đặt cược không chính xác',
    1205: 'Số tiền đặt cược không được để trống',
    1206: 'Định dạng số tiền đặt cược không chính xác',
    1207: 'Số tiền đặt cược quá lớn và không được lớn hơn XXXXXX',
    1208: 'Số tiền đặt cược quá nhỏ và không được nhỏ hơn 10',
    1209: 'Định dạng số tiền đặt cược bị lỗi, tối đa 2 chữ số thập phân',
    1210: 'Lỗi tham số quét mã QR Huione',
    1211: 'Mã số không được để trống',
    1212: 'Tham số không được để trống',
    1213: 'Loại hình nhận không chính xác',
    1214: 'Không có tiền hoa hồng nào có thể nhận',
    1215: 'Vui lòng nhập thông tin truy vấn',
    1216: 'Thông tin tiêu đề không được để trống',
    1217: 'Thông tin nội dung không được để trống',
    1218: 'id lì xì không được để trống',
    1219: 'Thông tin lì xì không tồn tại',
    1220: 'Tổng số tiền lì xì không được để trống',
    1221: 'Tổng số tiền lì xì không đúng định dạng',
    1222: 'Tổng số tiền lì xì phải lớn hơn 1',
    1223: 'Số lượng lì xì không được để trống',
    1224: 'Định dạng số lượng lì xì không đúng',
    1225: 'Tổng số tiền lì xì không được nhỏ hơn số lượng lì xì',
    1226: 'Loại hình lì xì không được để trống hoặc định dạng không đúng',
    1227: 'Lì xì khuyến mãi phải chỉ định ID người dùng',
    1228: 'Số tiền tối đa không được để trống',
    1229: 'Định dạng số tiền tối đa không đúng',
    1230: 'Số tiền tối đa trong lì xì không được nhỏ hơn 1',
    1231: 'Số tiền tối thiểu không được để trống',
    1232: 'Số tiền tối thiểu không đúng',
    1233: 'Số tiền tối thiểu trong lì xì không được nhỏ hơn 1',
    1234: 'Số tiền tối thiểu lớn hơn số tiền tối đa',
    1235: 'Hạn chót không được để trống',
    1236: 'Định dạng hạn chót không đúng',
    1237: 'Hạn chót không được sớm hơn thời gian hiện tại',
    1238: 'Lỗi logic số học: [Số tiền lớn nhất] × [Số lượng bao lì xì] không được nhỏ hơn [Tổng số tiền]',
    1239: 'Lỗi logic số học: [Số tiền nhỏ nhất] × [Số lượng bao lì xì] không được lớn hơn [Tổng số tiền]',
    1240: 'Bội số doanh thu chi tiêu không đáp ứng yêu cầu',
    1241: 'Vượt quá hạn mức lì xì bạn đã thiết lập',
    1242: 'Phát bao lì xì không thành công. Vui lòng thử lại',
    1243: 'Thưởng hoạt động đã được phát đi',
    1244: 'Tổng vòng cược không đủ để tham gia hoạt động',
    1245: 'Người dùng phát lì xì khuyến mãi không tồn tại',
    1246: 'Số dư người dùng phát bao lì xì khuyến mãi không đủ',
    1247: 'Cập nhật trạng thái tặng thưởng người mới của người dùng thất bại',
    1248: 'Lì xì đã hết hạn',
    1249: 'Chỉ hội viên mới mới có thể nhận bao lì xì người mới',
    1250: 'Chỉ cấp dưới mới có thể nhận bao lì xì',
    1251: 'Bao lì xì này chỉ dành cho thành viên được chỉ định nhận',
    1252: 'Bao lì xì này đã có người nhận',
    1253: 'Bao lì xì đã có người nhận',
    1254: 'Bao lì xì đã bị hủy',
    1255: 'Lì xì đã quá hạn',
    1256: 'Lỗi truy vấn dữ liệu lì xì',
    1257: 'Người dùng hiện tại đã liên kết địa chỉ email và không thể liên kết lại',
    1258: 'Địa chỉ email không được để trống',
    1259: 'Địa chỉ email không chính xác',
    1260: 'Email hiện tại đã được liên kết với người dùng khác. Vui lòng thay đổi email',
    1261: 'Mã xác minh email không được để trống',
    1262: 'Mã xác minh email không chính xác',
    1263: 'Mã xác minh email đã hết hạn',
    1264: 'Người dùng hiện tại chưa liên kết địa chỉ email, không thể sửa đổi',
    1265: 'Mã xác minh email ban đầu không chính xác. Liên kết thất bại',
    1266: 'Địa chỉ email ban đầu không được để trống',
    1267: 'Mã xác minh email ban đầu không được để trống',
    1268: 'Địa chỉ email mới không được để trống',
    1269: 'Mã xác minh email mới không được để trống',
    1270: 'Địa chỉ email ban đầu không chính xác',
    1271: 'Định dạng địa chỉ email ban đầu không chính xác',
    1272: 'Định dạng địa chỉ email mới không chính xác',
    1273: 'Email hiện tại đã được liên kết với người dùng khác. Vui lòng thay đổi email',
    1274: 'Mã xác minh email ban đầu đã hết hạn. Liên kết thất bại',
    1275: 'Mã xác minh email ban đầu không chính xác. Liên kết thất bại',
    1276: 'Mã xác minh email mới không chính xác. Liên kết thất bại',
    1277: 'Mã xác minh email mới đã hết hạn, liên kết thất bại',
    1278: 'Tài khoản đã được thiết lập và không thể đặt lại',
    1279: 'Mật khẩu rút tiền đã được thiết lập và không thể đặt lại',
    1280: 'Tên người dùng này đã tồn tại, vui lòng nhập lại',
    1281: 'Mật khẩu tài khoản chưa được thiết lập, vui lòng thiết lập tài khoản',
    1282: 'Mật khẩu ban đầu không được để trống',
    1283: 'Mật khẩu mới không được để trống',
    1284: 'Định dạng mật khẩu ban đầu không chính xác',
    1285: 'Định dạng mật khẩu mới không chính xác',
    1286: 'Mật khẩu ban đầu không chính xác',
    1287: 'Mật khẩu rút tiền không được để trống',
    1288: 'Vui lòng sử dụng mật khẩu rút tiền từ 6-20 ký tự',
    1289: 'Định dạng mật khẩu rút tiền không chính xác',
    1290: 'Mật khẩu rút tiền chưa được thiết lập. Vui lòng thiết lập mật khẩu rút tiền',
    1291: 'Mật khẩu rút tiền ban đầu không được để trống',
    1292: 'Mật khẩu rút tiền mới không được để trống',
    1293: 'Định dạng mật khẩu rút tiền ban đầu không chính xác',
    1294: 'Định dạng mật khẩu rút tiền mới không chính xác',
    1295: 'Mật khẩu rút tiền ban đầu không chính xác',
    1296: 'Mật khẩu đăng nhập không được để trống',
    1297: 'Thao tác thường xuyên, vui lòng thử lại sau',
    1298: 'Email chưa được liên kết với người dùng, vui lòng thay đổi email',
    1299: 'Vui lòng liên kết email',
    1300: 'Gửi đi thất bại, vui lòng liên hệ bộ phận chăm sóc khách hàng',
    1301: 'Bạn chưa thiết lập email hoặc vui lòng nhập email hợp lệ',
    1302: 'Vui lòng nhận hoa hồng sau 2 giờ',
    1303: 'Vượt qua hạn mức lì xì bạn đã cài đặt',
    1304: 'Nhiệm vụ vòng cược còn XXXXXX chưa hoàn thành， tạm thời không thể rút tiền',
    1305: 'Số tiền rút không được dưới XXXXXX',
    1306: 'XXXXXX Vui lòng hoàn tất nhiệm vụ vòng cược bắt buộc XXXXXX',
    1307: 'Đại lý không tồn tại',
    1308: 'Số tiền bao lì xì trung bình không được nhỏ hơn 0,01',
    1309: 'Số tiền rút phải có tối đa 2 chữ số thập phân',
    1310: 'Mật mã đăng nhập không chính xác',
    1311: 'Mã xác nhận không được để trống',
    1313: 'Mã xác nhận TG không chính xác',
    1314: 'Rất tiếc, bạn không được phép gửi bao lì xì!',
    1315: 'Mật khẩu bạn nhập quá đơn giản. Vui lòng nhập lại',
    1316: 'Rất tiếc, trò chơi này hiện chưa khả dụng',
    1317: 'Hiện tại, bạn không thể sửa đổi địa chỉ rút tiền. Vui lòng liên hệ bộ phận chăm sóc khách hàng để được tư vấn!',
    1318: 'Định dạng số tiền không chính xác.',
    1319: 'Số dư của bạn không đủ',
    1320: 'Tiền thưởng tuần này đã nhận và không thể lặp lại',
    1321: 'Đặt cược có hiệu lực trong tuần không đủ, không thể nhận',
    1322: 'Không có số tiền thưởng ở cấp hiện tại, không thể nhận',
    1323: 'Bạn đã kích hoạt thẻ tháng và không thể kích hoạt lại',
    1324: 'Phải trả phí để kích hoạt thẻ tháng, số dư không đủ',
    1325: 'Vui lòng kích hoạt thẻ khuyến mãi tháng trước khi nhận',
    1326: 'Phần thưởng khuyến mãi hôm nay đã được nhận và không thể nhận lại',
    1327: 'Thông số yêu cầu bị lỗi',
    1328: 'Hiện chưa có lịch sử nhận thưởng nào phù hợp với điều kiện',
    1329: 'Vui lòng nhận phần thưởng cấp trên trước',
    1330: 'Số tiền rút phải là số chẵn',
    1331: 'Lỗi khi lấy thông tin tên miền',
    1332: 'Hiện chưa hỗ trợ quét mã Huione',
    1333: 'Bao lì xì chỉ có thể nhận trong khu vực được chỉ định',
    1334: 'Vượt quá giới hạn tổng số cho mỗi kỳ XXXXXXX',
    1335: 'Chức năng bao lì xì hiện chưa được mở',
    1336: '',
    1337: '',
    1338: '',
    1339: '',
    1340: '',
    1341: '',
    1342: '',
    1343: '',
    1344: '',
    1345: '',
    1346: '',
    1347: '',
    1348: '',
    1349: '',
    1350: '',
    1351: '',
    1352: '',
    1353: '',
    1354: '',
    1355: '',
    1356: '',
    1357: '',
    1358: '',
    1359: '',
    1360: '',
    1361: '',
    1362: '',
    1363: '',
    1364: '',
    1365: '',
    1366: '',
    1367: '',
    1368: '',
    1369: '',
    1370: '',
    1371: '',
    1372: '',
    1373: '',
    1374: '',
    1375: '',
    1376: '',
    1377: '',
    1378: '',
    1379: '',
    1380: '',
    1381: '',
    1382: '',
    1383: '',
    1384: '',
    1385: '',
    1386: '',
    1387: '',
    1388: '',
    1389: '',
    1390: '',
    1391: '',
    1392: '',
    1393: '',
    1394: '',
    1395: '',
    1396: '',
    1397: '',
    1398: '',
    1399: '',
    1400: ''
  }
  // ...zhLocale //这里引入element语言包目的是在切换语言的时候，element的组件里面的文字能跟随切换 Mục đích nhập gói ngôn ngữ của Element ở đây là khi chuyển đổi ngôn ngữ, đặtc nội dung văn bản trong đặtc thành phần của Element có thể thay đổi theo.
}
// 导出 Xuất ra
export default cn
